export function lineClues(cells: readonly number[]): number[] {
  const clues: number[] = [];
  let run = 0;

  for (const cell of cells) {
    if (cell === 1) {
      run += 1;
    } else if (run > 0) {
      clues.push(run);
      run = 0;
    }
  }

  if (run > 0) clues.push(run);
  return clues;
}

export function deriveClues(solution: readonly number[], size: number): {
  rowClues: number[][];
  columnClues: number[][];
} {
  if (solution.length !== size * size) {
    throw new Error(`Expected ${size * size} cells, received ${solution.length}.`);
  }

  const rowClues = Array.from({ length: size }, (_, row) =>
    lineClues(solution.slice(row * size, (row + 1) * size)),
  );
  const columnClues = Array.from({ length: size }, (_, column) =>
    lineClues(Array.from({ length: size }, (_, row) => solution[row * size + column] ?? 0)),
  );

  return { rowClues, columnClues };
}

export function cluesEqual(left: readonly number[], right: readonly number[]): boolean {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

/**
 * Which clues on a line can be ticked off from the current fills.
 *
 * Filled runs match from both ends, so a finished 2 at the top of a 2 6 column
 * counts while the 6 is still open. A run is not reused from both ends: a single
 * filled 3 on a 3 3 line ticks only the first 3.
 */
export function completedClueFlags(
  actual: readonly number[],
  expected: readonly number[],
): boolean[] {
  const flags = expected.map(() => false);
  if (expected.length === 0) return flags;

  let left = 0;
  while (left < actual.length && left < expected.length && actual[left] === expected[left]) {
    flags[left] = true;
    left += 1;
  }

  let rightExpected = expected.length - 1;
  let rightActual = actual.length - 1;
  while (
    rightExpected >= left &&
    rightActual >= left &&
    actual[rightActual] === expected[rightExpected]
  ) {
    flags[rightExpected] = true;
    rightExpected -= 1;
    rightActual -= 1;
  }

  return flags;
}
